import Marquee from "react-fast-marquee";

const ITEMS = ["DEAR", "KL", "GOLDEN RAJA"];

export default function EditorialMarquee() {
  return (
    <section data-testid="editorial-marquee" className="overflow-hidden border-y border-white/10 py-10">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {[...ITEMS, ...ITEMS].map((item, i) => (
          <span key={i} className="mx-8 flex items-center gap-16">
            <span className="outline-text whitespace-nowrap font-heading text-[10vw] font-black uppercase leading-none tracking-tighter">
              {item}
            </span>
            <span className="text-[3vw] text-[#FFD700]">•</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
